import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { smartDocParamType_Dynamic, smartDocParamType_EHR, smartDocParamType_Static, smartDocParamTypeLabelMap } from '@app/advisor-content-shared';
export class DropDown_SmartDocParamType extends ComponentSync {
    adapter = SimpleListAdapter([
        smartDocParamType_Static,
        smartDocParamType_Dynamic,
        smartDocParamType_EHR,
    ], node => _jsx(_Fragment, { children: smartDocParamTypeLabelMap[node.item] }));
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        return state;
    }
    // ######################## Logic ########################
    onTypeSelected = async (type) => {
        const param = this.state.editable;
        // @ts-ignore
        param.updateItem({
            key: param.item.key,
            type: type
        });
        return param.save();
    };
    // ######################## Render ########################
    render() {
        const selected = this.state.editable.item.type;
        return _jsx(TS_DropDown, { adapter: this.adapter, selected: selected, onSelected: this.onTypeSelected, queryFilter: type => this.props.allowedParamTypes?.includes(type) ?? true });
    }
}
//# sourceMappingURL=DropDown_SmartDocParamType.js.map